import React from "react";
import { PageMeta } from "@/components/PageMeta";
import { Breadcrumbs } from "@/components/Breadcrumbs";
import { CtaBand } from "@/components/CtaBand";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { BRAND } from "@/config/brand";

const faqs = [
    { q: "How much do removals cost?", a: "Costs depend on volume, distance, floor level, access and any packing help required." },
    { q: "How is the quotation calculated?", a: "We consider inventory, property details at both ends, dates, parking and any special items." },
    { q: "Do you provide packing help?", a: "Yes — partial or full packing with materials." },
    { q: "Can you move one item?", a: "Yes, we offer single-item delivery across London." },
    { q: "Do you cover all of London?", a: "We work across Greater London and most surrounding boroughs." },
    { q: "Can I book at short notice?", a: "Same-day and short-notice moves are subject to availability. WhatsApp is fastest." },
    { q: "What information do you need for a quote?", a: "Postcodes, property types, floors, approximate inventory, preferred date, and special items." },
    { q: "Do we need to arrange parking?", a: "Where possible please reserve a suitable space or advise about restrictions." },
    { q: "What happens if the move takes longer?", a: "We’ll explain the quote structure in advance and communicate clearly if anything changes." },
    { q: "Can you dismantle and reassemble furniture?", a: "Yes — flag this when you request your quote and we’ll come prepared." },
];

export default function FAQ() {
    const ldJson = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faqs.map((f) => ({ "@type": "Question", name: f.q, acceptedAnswer: { "@type": "Answer", text: f.a } })),
    };
    return (
        <div>
            <PageMeta title="FAQ — YS Removals London" description="Common questions about London removals, quotations, packing and access." canonical={`https://${BRAND.domain}/faq`} ldJson={ldJson} />
            <section className="bg-[#001B3D] text-white">
                <div className="container-ys section">
                    <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "FAQ" }]} />
                    <h1 className="mt-3 text-4xl sm:text-5xl font-semibold tracking-tight font-heading">Frequently asked questions</h1>
                </div>
            </section>
            <section className="container-ys section">
                <div className="rounded-2xl bg-white border border-[#17252D]/10 p-2 sm:p-4">
                    <Accordion type="single" collapsible>
                        {faqs.map((f, i) => (
                            <AccordionItem key={i} value={`f-${i}`}>
                                <AccordionTrigger className="text-left font-heading">{f.q}</AccordionTrigger>
                                <AccordionContent className="text-[#17252D]/80">{f.a}</AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </div>
            </section>
            <CtaBand />
        </div>
    );
}
